// 'displayOrder' propery used to order breadcrump elements
// please dont override the existing id when adding new breadcrumb value

import { MEDICAL_UW_URL,MEDICAL_UW_HO_URL } from 'src/app/shared/constants/medical-uw-url.constants';  

export const BreadcrumbConfig = {
    data: {
        values: [
            // tslint:disable-next-line: max-line-length
            { id: 0, screenName: 'OnlineQuote', name: 'Online quote', path: '/home/get-your-online-quote', type: 'intro', isActive: false, enable: false, displayOrder: 0 },
            // tslint:disable-next-line: max-line-length
            // { id: 1, screenName: 'YouWillNeed', name: 'You will need', path: '/home/you-will-need', type: 'intro', isActive: false, enable: true, displayOrder: 1 },
            {
                id: 2, name: 'Guidance and Advice', path: '/home/guidance-and-advice', type: 'main',
                isActive: false, screenName: 'guidanceAndAdvice', enable: true, displayOrder: 2
            },
            {
                id: 3, name: 'Before you continue', path: '/home/before-you-start', type: 'main',
                isActive: false, screenName: 'beforestart', enable: true, displayOrder: 3
            },
            // PS21-21 removing the Pension details from breadcrumb
            {
                id: 9999, name: 'Personal details', path: '/home/your-personal-details', type: 'main',
                isActive: false, screenName: 'Customer', enable: false, displayOrder: 9999
            },
            {
                id: 5, name: 'Your pension', path: '/home/your-pension-savings', type: 'main',
                isActive: false, screenName: 'CedingFunds', enable: true, displayOrder: 5
            },
            {
                id: 6, name: 'Product choice', path: '/home/your-product-choice', type: 'main',
                isActive: false, screenName: 'productChoice', enable: true, displayOrder: 6
            },
            {
                id: 14, name: 'Your dependant', path: '/home/your-dependant',
                type: 'main', isActive: false, screenName: 'Dependant', enable: true, displayOrder: 14
            },
            {
                id: 15, name: 'Dependant’s lifestyle', path: MEDICAL_UW_URL.dependant.dependantLifestyle,
                type: 'main', isActive: false, screenName: 'dependant-lifestyle', enable: false, displayOrder: 15
            },
            {
                id: 16, name: 'Dependant’s medical conditions', path: MEDICAL_UW_URL.dependant.dependantMedicalConditions,
                type: 'main', isActive: false, screenName: 'dependant-medical-conditions', enable: false, displayOrder: 16
            },
            {
                id: 17, screenName: 'Dependant’s amc', name: 'Dependant’s AMC',
                path: MEDICAL_UW_URL.dependant.dependantAMC, type: 'main', isActive: false, enable: false, displayOrder: 17
            },
            {
                id: 18, screenName: "Your dependant's medical condition content", name: 'Dependant’s Diabetes',
                path: MEDICAL_UW_URL.dependant.dependantDiabetes, type: 'main', isActive: false, enable: false, displayOrder: 18
            },
            {
                id: 19, screenName: 'Your dependant - Medical condition questionnaire', name: 'Dependant’s DMC',
                path: MEDICAL_UW_URL.dependant.dependantDMC, type: 'main', isActive: false, enable: false, displayOrder: 19
            },
            {
                id: 20, screenName: 'Dependant’s activities-of-daily-living', name: 'Dependant’s ADL',
                path: MEDICAL_UW_URL.dependant.dependantADL, type: 'main', isActive: false, enable: false, displayOrder: 20
            },
            {
                id: 21, screenName: "Dependant’s doctor's-details", name: "Dependant’s Doctor's details",
                path: MEDICAL_UW_URL.dependant.dependantDoctorDetails, type: 'main', isActive: false, enable: false, displayOrder: 21
            },
            // tslint:disable-next-line: max-line-length
            {
                id: 22, name: 'Option and quote', path: '/quote/your-product-options', screenName: 'Option & Quote', type: 'main',
                isActive: false, enable: true, displayOrder: 22
            },
            // tslint:disable-next-line:max-line-length
            {
                id: 23, name: 'quote-playback', path: '/quote/please-confirm-your-details', screenName: 'quote-playback', type: 'main',
                isActive: false, enable: false, displayOrder: 23
            },
            // tslint:disable-next-line: max-line-length
            {
                id: 24, name: 'your-product-quote', path: '/quote/your-product-quote', screenName: 'your-product-quote', type: 'main',
                isActive: false, enable: false, displayOrder: 24
            },
            // tslint:disable-next-line: max-line-length
            {
                id: 25, name: 'your-saved-quotes', path: '/quote/your-saved-quotes', screenName: 'your-saved-quotes', type: 'main',
                isActive: false, enable: false, displayOrder: 25
            },
            // tslint:disable-next-line: max-line-length
            {
                id: 26, screenName: 'after-login', name: 'after-login', path: '/home/after-login', type: 'main', isActive: false,
                enable: false, displayOrder: 26
            },
            // tslint:disable-next-line:max-line-length
            {
                id: 27, screenName: 'registration', name: 'registration', path: '/home/registration', type: 'main', isActive: false,
                enable: false, displayOrder: 27
            },
            {
                // tslint:disable-next-line:max-line-length
                id: 59, screenName: 'post-registration-success', name: 'registration-success', path: '/home/post-registration/Success', type: 'main', isActive: false,
                enable: false, displayOrder: 59
            },
            {
                // tslint:disable-next-line:max-line-length
                id: 60, screenName: 'post-registration-failure', name: 'registration-failure', path: '/home/post-registration/Failure', type: 'main', isActive: false,
                enable: false, displayOrder: 60
            },
            {
                id: 37, screenName: 'update-my-details', name: 'update-my-details', path: '/home/update-my-details', type: 'main', isActive: false,
                enable: false, displayOrder: 37
            },
            {
                id: 7, name: 'Lifestyle', path: MEDICAL_UW_URL.annuitant.lifestyle,
                type: 'main', isActive: false, screenName: 'lifestyle', enable: true, displayOrder: 7
            },
            {
                id: 8, name: 'Medical conditions', path: MEDICAL_UW_URL.annuitant.medicalConditions,
                type: 'main', isActive: false, screenName: 'medical-conditions', enable: true, displayOrder: 8
            },
            {
                id: 9, screenName: 'amc', name: 'AMC',
                path: MEDICAL_UW_URL.annuitant.AMC, type: 'main', isActive: false, enable: false, displayOrder: 9
            },
            {
                id: 9, screenName: 'Medical condition content', name: 'Diabetes',
                path: MEDICAL_UW_URL.annuitant.diabetes, type: 'main', isActive: false, enable: false, displayOrder: 10
            },
            {
                id: 11, screenName: 'Medical condition questionnaire', name: 'DMC',
                path: MEDICAL_UW_URL.annuitant.DMC, type: 'main', isActive: false, enable: false, displayOrder: 11
            },
            {
                id: 12, screenName: 'activities-of-daily-living', name: 'Activities of daily living',
                path: MEDICAL_UW_URL.annuitant.ADL, type: 'main', isActive: false, enable: false, displayOrder: 12
            },
            {
                id: 13, screenName: "doctor's-details", name: "Doctor's details",
                path: MEDICAL_UW_URL.annuitant.doctorDetails, type: 'main', isActive: false, enable: true, displayOrder: 13
            },
            // Apply journey
            {
                id: 28, screenName: 'clear-to-apply', name: 'Clear to apply',
                path: '/apply/clear-to-apply', type: 'apply', isActive: false, enable: true, displayOrder: 28
            },
            {
                // tslint:disable-next-line: max-line-length
                id: 29, screenName: 'your-personal-details', name: 'Personal details',
                path: '/apply/your-personal-details', type: 'apply', isActive: false, enable: true, displayOrder: 29
            },
            {
                // tslint:disable-next-line: max-line-length
                id: 30, screenName: 'your health records', name: 'Medical records',
                path: '/apply/your-doctors-details', type: 'apply', isActive: false, enable: true, displayOrder: 30
            },
            {
                // tslint:disable-next-line:max-line-length
                id: 31, screenName: 'your-dependant-details', name: 'Your dependant',
                path: '/apply/your-dependant-details', type: 'apply', isActive: false,
                enable: true, displayOrder: 31
            },
            
            {
                // tslint:disable-next-line: max-line-length
                id: 32, screenName: 'dependant health records', name: 'Dependant\'s medical records',
                path: '/apply/your-dependants-doctors-details', type: 'apply', isActive: false,
                enable: true, displayOrder: 32
            },
            {
                // tslint:disable-next-line:max-line-length
                id: 33, screenName: 'your-pension-savings', name: 'Pension savings', path: '/apply/your-pension-savings', type: 'apply', isActive: false,
                enable: true, displayOrder: 33
            },
            {
                id: 34, screenName: 'your-lump-sum-allowances', name: 'Your Lump Sum Allowances',
                path: '/apply/your-lump-sum-allowances', type: 'apply', isActive: false, enable: false, displayOrder: 34
            },
            {
                // tslint:disable-next-line:max-line-length
                id: 35, screenName: 'your-beneficiary-details', name: 'Beneficiary details', path: '/apply/your-beneficiary-details', type: 'apply', isActive: false,
                enable: false, displayOrder: 35
            },
            {
                // tslint:disable-next-line:max-line-length
                id: 36, screenName: 'your-payment-details', name: 'Income payment details', path: '/apply/your-payment-details', type: 'apply', isActive: false,
                enable: true, displayOrder: 36
            },
            {
                // tslint:disable-next-line:max-line-length
                id: 37, screenName: 'your-product-application', name: 'Confirm, sign and submit', path: '/apply/your-product-application', type: 'apply', isActive: false,
                enable: true, displayOrder: 37
            },
            {
                // tslint:disable-next-line:max-line-length
                id: 38, screenName: 'congratulations', name: 'Congratulations', path: '/apply/congratulations', type: 'apply', isActive: false,
                enable: false, displayOrder: 38
            },
            {
                // tslint:disable-next-line: max-line-length
                id: 42, screenName: 'ho-lifestyle', name: 'ho-lifestyle', path: MEDICAL_UW_HO_URL.annuitant.lifestyle, type: 'main', isActive: false,
                enable: false, displayOrder: 42
            },
            {
                // tslint:disable-next-line: max-line-length
                id: 43, screenName: 'ho-medical-conditions', name: 'Medical conditions', path: MEDICAL_UW_HO_URL.annuitant.medicalConditions, type: 'main', isActive: false,
                 enable: false, displayOrder: 43
            },
            {
                id: 44, screenName: 'amc', name: 'AMC',
                path: MEDICAL_UW_HO_URL.annuitant.AMC, type: 'main', isActive: false, enable: false, displayOrder: 44
            },
            {
                id: 45, screenName: 'Medical condition content', name: 'Diabetes',
                path: MEDICAL_UW_HO_URL.annuitant.diabetes, type: 'main', isActive: false, enable: false, displayOrder: 45
            },
            {
                id: 46, screenName: 'Medical condition questionnaire', name: 'DMC',
                path: MEDICAL_UW_HO_URL.annuitant.DMC, type: 'main', isActive: false, enable: false, displayOrder: 46
            },
            {
                id: 47, screenName: 'activities-of-daily-living', name: 'Activities of daily living',
                path: MEDICAL_UW_HO_URL.annuitant.ADL, type: 'main', isActive: false, enable: false, displayOrder: 47
            },
            {
                id: 48, screenName: "doctor's-details", name: "Doctor's details",
                path: MEDICAL_UW_HO_URL.annuitant.doctorDetails, type: 'main', isActive: false, enable: false, displayOrder: 48
            },
            {
                id: 49, screenName: 'ho-summary', name: 'ho summary',
                path: 'ho-underwriting/summary', type: 'main', isActive: false, enable: false, displayOrder: 49
            },
            {
                // tslint:disable-next-line: max-line-length
                id: 50, screenName: 'ho-dependant-lifestyle', name: 'Dependant’s lifestyle', path: MEDICAL_UW_HO_URL.dependant.dependantLifestyle,
                 type: 'main', isActive: false,
                 enable: false, displayOrder: 50
            },
            {
                // tslint:disable-next-line: max-line-length
                id: 51, screenName: 'ho-dependant-medical-conditions', name: 'Dependant’s medical conditions', path: MEDICAL_UW_HO_URL.dependant.dependantMedicalConditions,
                 type: 'main', isActive: false,
                 enable: false, displayOrder: 51
            },
            {
                // tslint:disable-next-line: max-line-length
                id: 52, screenName: 'ho-Dependant’s amc', name: 'Dependant’s AMC', path: MEDICAL_UW_HO_URL.dependant.dependantAMC,
                 type: 'main', isActive: false,
                 enable: false, displayOrder: 52
            },
            {
                // tslint:disable-next-line: max-line-length
                id: 53, screenName: "ho-Your dependant's medical condition content", name: 'Dependant’s Diabetes', path: MEDICAL_UW_HO_URL.dependant.dependantDiabetes,
                 type: 'main', isActive: false,
                 enable: false, displayOrder: 53
            },
            {
                // tslint:disable-next-line: max-line-length
                id: 54, screenName: 'ho-Your dependant - Medical condition questionnaire', name: 'Dependant’s DMC', path: MEDICAL_UW_HO_URL.dependant.dependantDMC,
                 type: 'main', isActive: false,
                 enable: false, displayOrder: 54
            },
            {
                // tslint:disable-next-line: max-line-length
                id: 55, screenName: 'ho-Dependant’s activities-of-daily-living', name: 'Dependant’s ADL', path: MEDICAL_UW_HO_URL.dependant.dependantADL,
                 type: 'main', isActive: false,
                 enable: false, displayOrder: 55
            },
            {
                // tslint:disable-next-line: max-line-length
                id: 56, screenName: "Dependant’s doctor's-details", name: "Dependant’s Doctor's details", path: MEDICAL_UW_HO_URL.dependant.dependantDoctorDetails,
                 type: 'main', isActive: false,
                 enable: false, displayOrder: 56
            },
            {
                // tslint:disable-next-line: max-line-length
                id: 57, screenName: 'un supported Browser', name: 'un supported Browser', path: '/home/un-support/resolution',
                 type: 'main', isActive: false,
                 enable: false, displayOrder: 57
            },
			{
                // tslint:disable-next-line: max-line-length
                id: 58, screenName: 'logout', name: 'logout', path: '/home/logout', type: 'logout', isActive: false,
                 enable: false, displayOrder: 58
            } ,           /* {
                id: 47, screenName: 'doctor-details', name: 'Doctor details',
                path: MEDICAL_UW_HO_URL.annuitant.doctorDetails, type: 'main', isActive: false, enable: true, displayOrder: 47
            } */
            // added for user login required
             
            {
                id: 61, name: 'user-login-required', path: '/apply/user-login-required', screenName: 'user-login-required', type: 'login',
                isActive: false, enable: false, displayOrder: 61
            },
        ]
    },
    authServer: [
        {
            serverName: 'localhost',
            secAuthUrl: 'http://lamstwas111.lgnet.co.uk:8080',
            entryPointUrl: 'http%3A%2F%2Flocalhost.lgnet.co.uk%3A8080',
            resetPasswordURL: 'http://lamstwas111.lgnet.co.uk:8080'
        },
        {
            serverName: 'lamstwas023',
            secAuthUrl: 'http://lamstwas111.lgnet.co.uk:8080',
            entryPointUrl: 'http%3A%2F%2Flamstwas023.lgnet.co.uk%3A8080',
            resetPasswordURL: 'http://lamstwas111.lgnet.co.uk:8080'
        },
        {
            serverName: 'lamstwas068',
            secAuthUrl: 'http://lamstwas111.lgnet.co.uk:8080',
            entryPointUrl: 'http%3A%2F%2Flamstwas068%3A8080',
            resetPasswordURL: 'http://lamstwas111.lgnet.co.uk:8080'
        },
        {
            serverName: 'lamstwas016',
            secAuthUrl: 'lamstwas111.lgnet.co.uk:8080',
            entryPointUrl: 'http%3A%2F%2Flamstwas111.lgnet.co.uk%3A8080',
            resetPasswordURL: 'lamstwas111.lgnet.co.uk:8080'
        },
		{
            serverName: 'retirements-qa1-weu-in',
            secAuthUrl: 'http://lamstwas111.lgnet.co.uk:8080',
            entryPointUrl: 'http%3A%2F%2Fretirements-qa1-weu-in.lgnet.co.uk%3A8080',
            resetPasswordURL: 'http://lamstwas111.lgnet.co.uk:8080'
        },
		{
            serverName: 'retirements-qa6-weu-in',
            secAuthUrl: 'http://lamstwas111.lgnet.co.uk:8080',
            entryPointUrl: 'http%3A%2F%2Fretirements-qa6-weu-in.lgnet.co.uk%3A8080',
            resetPasswordURL: 'http://lamstwas111.lgnet.co.uk:8080'
        },
        {
            serverName: 'retirements-qa2-weu-in',
            secAuthUrl: 'http://lamstwas111.lgnet.co.uk:8080',
            entryPointUrl: 'http%3A%2F%2Fretirements-qa2-weu-in.lgnet.co.uk%3A8080',
            resetPasswordURL: 'http://lamstwas111.lgnet.co.uk:8080'
        },
        {
            serverName: 'retirements-qa3-weu-in',
            secAuthUrl: 'http://lamstwas111.lgnet.co.uk:8080',
            entryPointUrl: 'http%3A%2F%2Fretirements-qa3-weu-in.lgnet.co.uk%3A8080',
            resetPasswordURL: 'http://lamstwas111.lgnet.co.uk:8080'
        },
        {
            serverName: 'retirements-qa4-weu-in',
            secAuthUrl: 'http://lamstwas111.lgnet.co.uk:8080',
            entryPointUrl: 'http%3A%2F%2Fretirements-qa4-weu-in.lgnet.co.uk%3A8080',
            resetPasswordURL: 'http://lamstwas111.lgnet.co.uk:8080'
        },
        {
            serverName: 'retirements-qa5-weu-in',
            secAuthUrl: 'http://lamstwas111.lgnet.co.uk:8080',
            entryPointUrl: 'http%3A%2F%2Fretirements-qa5-weu-in.lgnet.co.uk%3A8080',
            resetPasswordURL: 'http://lamstwas111.lgnet.co.uk:8080'
        },
        {
            serverName: 'retirements-qa6-weu-in',
            secAuthUrl: 'http://lamstwas111.lgnet.co.uk:8080',
            entryPointUrl: 'http%3A%2F%2Fretirements-qa6-weu-in.lgnet.co.uk%3A8080',
            resetPasswordURL: 'http://lamstwas111.lgnet.co.uk:8080'
        },
        {
            serverName: 'retirements-qa7-weu-in',
            secAuthUrl: 'http://lamstwas111.lgnet.co.uk:8080',
            entryPointUrl: 'http%3A%2F%2Fretirements-qa7-weu-in.lgnet.co.uk%3A8080',
            resetPasswordURL: 'http://lamstwas111.lgnet.co.uk:8080'
        },
        {
            serverName: 'retirements-qa8-weu-in',
            secAuthUrl: 'http://lamstwas111.lgnet.co.uk:8080',
            entryPointUrl: 'http%3A%2F%2Fretirements-qa8-weu-in.lgnet.co.uk%3A8080',
            resetPasswordURL: 'http://lamstwas111.lgnet.co.uk:8080'
        },
        {
            serverName: 'retirements-qa9-weu-in',
            secAuthUrl: 'http://lamstwas111.lgnet.co.uk:8080',
            entryPointUrl: 'http%3A%2F%2Fretirements-qa9-weu-in.lgnet.co.uk%3A8080',
            resetPasswordURL: 'http://lamstwas111.lgnet.co.uk:8080'
        },
        {
            serverName: 'retirements-devops-weu-in',
            secAuthUrl: 'http://lamstwas111.lgnet.co.uk:8080',
            entryPointUrl: 'http%3A%2F%2Fretirements-devops-weu-in.lgnet.co.uk%3A8080',
            resetPasswordURL: 'http://lamstwas111.lgnet.co.uk:8080'
        },
        {
            serverName: 'retirements-pp2',
            secAuthUrl: 'https://wwwpp10.landg.com',
            entryPointUrl: 'https%3A%2F%2Fretirements-pp2.landg.com',
            resetPasswordURL: 'https://wwwpp10.landg.com'
        },
        {
            serverName: 'retirements-pp',
            secAuthUrl: 'https://wwwpp10.landg.com',
            entryPointUrl: 'https%3A%2F%2Fretirements-pp.landg.com',
            resetPasswordURL: 'https://wwwpp10.landg.com'
        },
        {
            serverName: 'retirements',
            secAuthUrl: 'https://www10.landg.com',
            entryPointUrl: 'https%3A%2F%2Fretirements.landg.com',
            resetPasswordURL: 'https://www10.landg.com'
        },
        // Azure Kubernetes URLs
        {
            serverName: 'qa-1.in.qa.eap.lgrr',
            secAuthUrl: 'http://lamstwas111.lgnet.co.uk:8080',
            entryPointUrl: 'https%3A%2F%2Fqa-1.in.qa.eap.lgrr.lgnet.co.uk',
            resetPasswordURL: 'http://lamstwas111.lgnet.co.uk:8080'
        },
        {
            serverName: 'qa-2.in.qa.eap.lgrr',
            secAuthUrl: 'http://lamstwas111.lgnet.co.uk:8080',
            entryPointUrl: 'https%3A%2F%2Fqa-2.in.qa.eap.lgrr.lgnet.co.uk',
            resetPasswordURL: 'http://lamstwas111.lgnet.co.uk:8080'
        },
        {
            serverName: 'qa-3.in.qa.eap.lgrr',
            secAuthUrl: 'http://lamstwas111.lgnet.co.uk:8080',
            entryPointUrl: 'https%3A%2F%2Fqa-3.in.qa.eap.lgrr.lgnet.co.uk',
            resetPasswordURL: 'http://lamstwas111.lgnet.co.uk:8080'
        },
        {
            serverName: 'qa-4.in.qa.eap.lgrr',
            secAuthUrl: 'http://lamstwas111.lgnet.co.uk:8080',
            entryPointUrl: 'https%3A%2F%2Fqa-4.in.qa.eap.lgrr.lgnet.co.uk',
            resetPasswordURL: 'http://lamstwas111.lgnet.co.uk:8080'
        },
        {
            serverName: 'qa-5.in.qa.eap.lgrr',
            secAuthUrl: 'http://lamstwas111.lgnet.co.uk:8080',
            entryPointUrl: 'https%3A%2F%2Fqa-5.in.qa.eap.lgrr.lgnet.co.uk',
            resetPasswordURL: 'http://lamstwas111.lgnet.co.uk:8080'
        },
       
        {
            serverName: 'qa-6.in.qa.eap.lgrr',
            secAuthUrl: 'http://lamstwas111.lgnet.co.uk:8080',
            entryPointUrl: 'https%3A%2F%2Fqa-6.in.qa.eap.lgrr.lgnet.co.uk',
            resetPasswordURL: 'http://lamstwas111.lgnet.co.uk:8080'
        },
        {
            serverName: 'qa-7.in.qa.eap.lgrr',
            secAuthUrl: 'http://lamstwas111.lgnet.co.uk:8080',
            entryPointUrl: 'https%3A%2F%2Fqa-7.in.qa.eap.lgrr.lgnet.co.uk',
            resetPasswordURL: 'http://lamstwas111.lgnet.co.uk:8080'
        },
        {
            serverName: 'qa-8.in.qa.eap.lgrr',
            secAuthUrl: 'http://lamstwas111.lgnet.co.uk:8080',
            entryPointUrl: 'https%3A%2F%2Fqa-8.in.qa.eap.lgrr.lgnet.co.uk',
            resetPasswordURL: 'http://lamstwas111.lgnet.co.uk:8080'
        },

        {
            serverName: 'qa-9.in.qa.eap.lgrr',
            secAuthUrl: 'http://lamstwas111.lgnet.co.uk:8080',
            entryPointUrl: 'https%3A%2F%2Fqa-9.in.qa.eap.lgrr.lgnet.co.uk',
            resetPasswordURL: 'http://lamstwas111.lgnet.co.uk:8080'
        },
        {
            serverName: 'pp-1.in.pp.eap.lgrr',
            secAuthUrl: 'https://wwwpp10.landg.com',
            entryPointUrl: 'https%3A%2F%2Fpp-1.in.pp.eap.lgrr.landg.com',
            resetPasswordURL: 'https://wwwpp10.landg.com'
        },
        {
            serverName: 'pp-1.pp.eap.lgrr',
            secAuthUrl: 'https://wwwpp10.landg.com',
            entryPointUrl: 'https%3A%2F%2Fpp-1.pp.eap.lgrr.landg.com',
            resetPasswordURL: 'https://wwwpp10.landg.com'
        },
        {
            serverName: 'pp-2.in.pp.eap.lgrr',
            secAuthUrl: 'https://wwwpp10.landg.com',
            entryPointUrl: 'https%3A%2F%2Fpp-2.in.pp.eap.lgrr.landg.com',
            resetPasswordURL: 'https://wwwpp10.landg.com'
        },
        {
            serverName: 'pp-3.in.pp.eap.lgrr',
            secAuthUrl: 'https://wwwpp10.landg.com',
            entryPointUrl: 'https%3A%2F%2Fpp-3.in.pp.eap.lgrr.landg.com',
            resetPasswordURL: 'https://wwwpp10.landg.com'
        },
        {
            serverName: 'retirement-pd.in.eap.lgrr',
            secAuthUrl: 'https://www10.landg.com',
            entryPointUrl: 'https%3A%2F%2Fretirement-pd.in.eap.lgrr.landg.com',
            resetPasswordURL: 'https://www10.landg.com'
        },
        {
            serverName: 'pp-2.pp.eap.lgrr',
            secAuthUrl: 'https://wwwpp10.landg.com',
            entryPointUrl: 'https%3A%2F%2Fpp-2.pp.eap.lgrr.landg.com',
            resetPasswordURL: 'https://wwwpp10.landg.com'
        }
    ]
};

export interface BreadcrumbToggleRule {
  key: string;
  expected: boolean;
  ids: number[];
  show: boolean;
  extraAction?: string; // marker for side-effects handled in component
}

export const BreadcrumbToggleRules: BreadcrumbToggleRule[] = [
  { key: 'selected', expected: true, ids: [15, 16, 21], show: true },
  { key: 'selected', expected: false, ids: [15, 16, 21], show: false },
  { key: 'hidden', expected: true, ids: [7, 8, 13, 14], show: false },
  { key: 'hidden', expected: false, ids: [7, 8, 13, 14], show: true },
  { key: 'hideDependatDetails', expected: true, ids: [10, 11, 12, 14], show: false },
  { key: 'hideDependatDetails', expected: false, ids: [10, 11, 12, 14], show: true },
  { key: 'ftrpcorpBreadCrum', expected: true, ids: [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21], show: false },
  { key: 'hideADL', expected: false, ids: [12], show: true },
  { key: 'hideADL', expected: true, ids: [12], show: false },
  { key: 'hideDepADL', expected: false, ids: [20], show: true },
  { key: 'hideDepADL', expected: true, ids: [20], show: false },
  { key: 'hideDependantApplyDetails', expected: true, ids: [31, 32], show: false },
  { key: 'hideDependantApplyDetails', expected: false, ids: [31, 32], show: true },
  { key: 'hideGMPDependantApplyDetails', expected: false, ids: [32], show: true },
  { key: 'hideGMPDependantApplyDetails', expected: true, ids: [32], show: false },
  { key: 'hideApplyPagesForFTRPCorp', expected: false, ids: [30, 31, 32], show: false },
  { key: 'hideApplyPagesForFTRPCorp', expected: true, ids: [30, 31, 32], show: true },
  { key: 'hideBeneficiaryApplyDetails', expected: true, ids: [35], show: false },
  { key: 'hideBeneficiaryApplyDetails', expected: false, ids: [35], show: true },
  { key: 'hideLumpSumAllowance', expected: true, ids: [34], show: false, extraAction: 'removeYourLumpSumAllowances' },
  { key: 'hideLumpSumAllowance', expected: false, ids: [34], show: true },
];

